import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

import Breadcrumb from '../Breadcrumb/Breadcrumb';
import DirectlandingPageMeta from './DirectlandingPageMeta';
import MethodologyModal from '../SelectFundsMethodology/MethodologyModal/MethodologyModal';

import checkmrk from '../../images/green-checkmark.svg';
import styles from './DirectLandingPage.css';

const SelectFundsLandingPage = () => {
    const [open, toggleModalOpen] = useState(false);
    return (
        <React.Fragment>
            <DirectlandingPageMeta pagename="Select Funds" />
            <div className="text-col">
                <div className="text-col-body">
                    <Breadcrumb name="T. Rowe Price® Select Funds" />
                    <h1 className="select-funds-title">
                        T. Rowe Price®<br /> Select Funds
                    </h1>
                    <p className="sf-blurb">
                        We screen our lineup of actively managed mutual funds
                        down to a simple list of diverse options, to help you
                        select your investments more easily.
                    </p>
                    <p>
                        To get a more detailed profile, including standardized
                        returns as of the most recent calendar quarter end,
                        click on any fund name.
                    </p>
                </div>
            </div>
            <div className="info-col">
                <div className="container">
                    <p className="listed-content">
                        <img
                            className="small-check-mrk"
                            alt="checkmark symbol"
                            src={checkmrk}
                        />{' '}
                        Overall Morningstar Rating™
                    </p>
                    <p className="listed-content">
                        <img
                            className="small-check-mrk"
                            alt="checkmark symbol"
                            src={checkmrk}
                        />{' '}
                        Morningstar Medalist Rating™
                    </p>
                    <p className="listed-content">
                        <img
                            className="small-check-mrk"
                            alt="checkmark symbol"
                            src={checkmrk}
                        />{' '}
                        Expense Ratios
                    </p>
                    <p className="listed-content">
                        <img
                            className="small-check-mrk"
                            alt="checkmark symbol"
                            src={checkmrk}
                        />{' '}
                        Net New Flows
                    </p>
                    <div className="browse-all-container">
                        <p className="browse-all sf-custom sf-review-criteria">
                            <button
                                onClick={() => toggleModalOpen(!open)}
                                type="button"
                            >
                                Review Criteria
                            </button>
                        </p>
                        <p className="browse-all sf-custom">
                            <NavLink exact to="/">
                                View All Funds
                            </NavLink>
                        </p>
                        <p className="browse-all sf-custom">
                            {/* anchor element used for navigation so filters apply correctly */}
                            <a href="/personal-investing/tools/fund-research/asset-allocation-funds">
                                Browse All-in-one Portfolios
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            {open && <MethodologyModal open onClose={toggleModalOpen} />}
            <style jsx>{styles}</style>
        </React.Fragment>
    );
};

export default SelectFundsLandingPage;
